import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import settings store
import { useSettingsStore } from '@/store/SettingsStore';

// Dynamic import of all translation files
const translationModules = import.meta.glob('./locales/*.json', { eager: true });

// Build resources object dynamically
const resources: Record<string, { translation: Record<string, string> }> = {};

Object.entries(translationModules).forEach(([path, module]) => {
  // Extract language code from file path (e.g., './locales/en.json' -> 'en')
  const languageCode = path.match(/\.\/locales\/(.+)\.json$/)?.[1];
  if (languageCode && module && typeof module === 'object' && 'default' in module) {
    resources[languageCode] = { translation: module.default as Record<string, string> };
  }
});

i18n.use(initReactI18next).init({
  resources,
  lng: useSettingsStore.getState().language || 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
});

export default i18n;
